import React from "react";
import  { useState, useEffect } from 'react';
import './classes/ScoutMainHome.css';
import { Link, useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';

const ScoutMainHome = () => {

    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const [isLoading, setIsLoading] = useState(true);
    const [scoutSports, setScoutSports] = useState([]);

    useEffect(() => {
        const staticData = [
            {   
                id: "1", 
                name: 'Baseball',
                image: '/basic/web/images/scout/sports1.jpg',
                url:'/scout-sports/baseball',
            },
            {   
                id: "2", 
                name: 'Basketball',
                image: '/basic/web/images/scout/sports2.jpg',
                url:'/scout-sports/basketball',
            },
            {   
                id: "3", 
                name: 'Football',
                image: '/basic/web/images/scout/sports3.jpg',
                url:'/scout-sports/football',
            },
            {   
                id: "4", 
                name: 'Hockey',
                image: '/basic/web/images/scout/sports5.jpg',
                url:'/scout-sports/hockey',
            },
            {   
                id: "5", 
                name: 'Rugby',
                image: '/basic/web/images/scout/sports6.jpg',
                url:'/scout-sports/rugby',
            },
            {   
                id: "6", 
                name: 'Soccer',
                image: '/basic/web/images/scout/sports4.jpg',
                url:'/scout-sports/soccer',
            },
        ];
        setScoutSports(staticData);
    },[]);

    useEffect(() => {
        Promise.all([
            
        ])
        .then(() => {
     
        setIsLoading(false);
        })
     
    },[]);

    const handleClick = (continent) => {
        navigate('/continents/'+continent+'/scouts');
    };

    const handleUSClick = () => {
        navigate('/sports_scouts_usmap');
    };

    const handleCanadaClick = () => {
        navigate('/sports-scout-canada-map');
    };
    
    return (
        <>
       {isLoading ? (
            <Loading />
        ) : ( 
            <div id="main" className="scout-home-main">
                <Helmet><title>Home Page Scouts</title></Helmet>
                <div className="left"></div>
                <div className="center left-center">
                    <div className="whiteboxr">
                        <div className="webtext"><h2>Click On The Map To Search Scouts Worldwide</h2></div>
                        <div className="mobiletext"><h2>Click On The Link To Search Scouts Worldwide</h2></div>
                        <div style={{textAlign: "center"}}>
                            <div className="mobilemaparea">
                            <h1><a 
                            // href="/sports-scout-canada-map"
                            onClick={(e) => {e.preventDefault(); handleCanadaClick();}}
                            >Scouts in Canada</a></h1>

                            <h1><a 
                            // href="/continents/1/scouts"
                            onClick={(e) => {e.preventDefault(); handleClick('1');}}
                            >Scouts in Mexico &amp; Central America</a></h1>

                            <h1><a 
                            // href="/sports_scouts_usmap"
                            onClick={(e) => {e.preventDefault(); handleUSClick();}}
                            >Scouts in USA</a></h1>

                            <h1><a 
                            // href="/continents/2/scouts"
                            onClick={(e) => {e.preventDefault(); handleClick('2');}}
                            >Scouts in South America</a></h1>

                            <h1><a 
                            // href="/continents/3/scouts"
                            onClick={(e) => {e.preventDefault(); handleClick('3');}}
                            >Scouts in Europe</a></h1>

                            <h1><a 
                            // href="/continents/4/scouts"
                            onClick={(e) => {e.preventDefault(); handleClick('4');}}
                            >Scouts in Asia &amp; Middle East</a></h1>

                            <h1><a 
                            // href="/continents/5/scouts"
                            onClick={(e) => {e.preventDefault(); handleClick('5');}}
                            >Scouts in Africa</a></h1>

                            <h1><a 
                            // href="/continents/6/scouts"
                            onClick={(e) => {e.preventDefault(); handleClick('6');}}
                            >Scouts in South Pacific</a></h1>
                            </div>
                            <div className="webmaparea">
                                <img
                                    src="/basic/web/images/scout/agencyhome-maps.jpg"
                                    alt="World Map"
                                    useMap="#Mapu"
                                    style={{
                                        width: '100%',
                                        maxWidth: '650px',
                                        height: 'auto'
                                    }}
                                />
                                <map name="Mapu" id="Mapu">
                                    <area 
                                        coords="4,31,68,90" 
                                        shape="rect" 
                                        onClick={(e) => {e.preventDefault(); handleUSClick();}}
                                        // href="/sports_scouts_usmap"
                                    />
                                    <area 
                                        coords="71,91,216,115" 
                                        shape="rect" 
                                        onClick={(e) => {e.preventDefault(); handleUSClick();}}
                                        // href="/sports_scouts_usmap"
                                    />
                                    <area 
                                        coords="65,8,295,91"
                                        shape="rect" 
                                        onClick={(e) => {e.preventDefault(); handleCanadaClick();}}
                                        // href="/sports-scout-canada-map"
                                    />
                                    <area 
                                        coords="78,113,214,153" 
                                        shape="rect" 
                                        onClick={(e) => {e.preventDefault(); handleClick('1');}}
                                    />
                                    <area 
                                        coords="154,153,263,282"
                                        shape="rect" 
                                        onClick={(e) => {e.preventDefault(); handleClick('2');}}
                                    />
                                    <area 
                                        coords="307,12,440,98" 
                                        shape="rect" 
                                        onClick={(e) => {e.preventDefault(); handleClick('3');}}
                                    />
                                    <area 
                                        coords="440,9,642,186"
                                        shape="rect" 
                                        onClick={(e) => {e.preventDefault(); handleClick('4');}}
                                    />
                                    <area 
                                        coords="911,330,1051,440"
                                        shape="rect" 
                                        onClick={(e) => {e.preventDefault(); handleClick('6');}}
                                    />
                                    <area 
                                        coords="539,187,633,265"
                                        shape="rect" 
                                        onClick={(e) => {e.preventDefault(); handleClick('6');}}
                                    />
                                    <area 
                                        coords="289,101,404,254" 
                                        shape="rect" 
                                        onClick={(e) => {e.preventDefault(); handleClick('5');}}
                                    />
                                    <area 
                                        coords="395,89,446,146"  
                                        shape="rect" 
                                        onClick={(e) => {e.preventDefault(); handleClick('4');}}
                                    />
                                </map>
                            </div>
                        </div>
                    </div>
                    <div className="whitebox nomargfr">
                        <h2>Request a Free Scouting<br />
                        Report on a Athlete</h2>
                        <div className="data2">Find a scout on the map, read their bio, and look at a sample of their scouting reports. If it meets your criteria, you contact them and give them a test scouting project.<br />
                        &nbsp;
                        <div style={{padding: "0% 5% 0% 5%"}}><a className="reddbtnn" href="/scouting-requests">Request Scouting Report</a></div>
                        </div>
                    </div>
                    <div style={{clear: "both"}}>&nbsp;</div>
                    {scoutSports.map((scoutSport, index) => (
                        <div className="linkbox" key={index}>
                            <a href={scoutSport.url}><img src={scoutSport.image} alt={scoutSport.name} /></a>
                        </div>
                    ))}
                    <h1 style={{clear:"both", paddingLeft:"0px", borderLeft:"none"}}>Connecting Athletes, Agents, Teams, and Scouts Worldwide.</h1>
                    <p>
                        Sports Management Worldwide (SMWW) offers trained scouts throughout the world. 
                        At Sports Management Worldwide, we train scouts in Football, Basketball, Soccer, Baseball, and Hockey. 
                        Each sport has it's nuances, as scouting is a learned skill with specific player evaluation, player ratings, and in-depth analysis. 
                        We are proud of our SMWW graduates as they have worked long and hard to attain the "eye" to evaluate talent and write a scouting report that meets your requirements.
                    </p>
                </div>
                <div className="right"></div>
            </div>
        )}
        </>
    );
};
export default ScoutMainHome;